module.exports = __webpack_public_path__ + "static/media/2019-08-16.f6d99998.md";